import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { PublicLayout } from '@/components/PublicLayout';
import { Kicker } from '@/components/Kicker';

function StatusBadge({ status }) {
  const map = {
    new: 'bg-[#FBEADD] text-[#E2611C]',
    in_progress: 'bg-[#F6F8FB] text-[#14171C]',
    done: 'bg-[#E7F6EE] text-[#1F7A4D]',
  };
  return <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${map[status] || map.new}`}>{status}</span>;
}

export default function MyRequestsPage() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['requests', 'mine'], queryFn: async () => (await api.get('/requests/mine')).data });
  const items = q.data?.items || [];
  return (
    <PublicLayout>
      <section className="pn-container py-10">
        <Kicker>{t('brand.portal')}</Kicker>
        <h1 className="mt-3 font-display text-3xl font-semibold text-[#14171C]">{t('nav.my_requests')}</h1>

        <div className="mt-8 pn-card overflow-hidden">
          <table className="w-full text-left text-sm" data-testid="my-requests-table">
            <thead className="bg-[#F6F8FB] text-xs uppercase tracking-wide text-[#4A4D52]">
              <tr>
                <th className="px-4 py-3">Datum</th>
                <th className="px-4 py-3">Produkt</th>
                <th className="px-4 py-3">Typ</th>
                <th className="px-4 py-3">Menge</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {q.isLoading && <tr><td colSpan={5} className="p-6 text-center text-[#4A4D52]">{t('common.loading')}</td></tr>}
              {!q.isLoading && items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-[#4A4D52]">{t('catalog.empty')}</td></tr>}
              {items.map((r) => (
                <tr key={r.id} className="border-t border-[#E4E9F0] hover:bg-[#F6F8FB]">
                  <td className="px-4 py-3 font-mono text-xs text-[#4A4D52]">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{r.product_name}</td>
                  <td className="px-4 py-3">{t(`request.${r.request_type}`)}</td>
                  <td className="px-4 py-3">{r.quantity || '—'}</td>
                  <td className="px-4 py-3"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </PublicLayout>
  );
}
